import React from "react";
import { Modal } from "reactstrap";
import AddMemoPopupInner from "./AddMemoPopupInner";

// 顧客メモ、仕入先メモ
export default class AddMemoPopup extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      data: {
        values: {},
        requiredData: {},
        errors: {},
      },
      updateMemo: this.props.updateMemo
    };

    this.toggleModal = this.toggleModal.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.setState({
        data: {
          ...this.props.data,
          values : {
            ...this.props.data.values,
            add_memo: ""
          },
          errors : {}
        }
      })
    }
  }

  show() {
    this.setState({ modal: true });
  }

  toggleModal() {
    this.setState({
      modal: !this.state.modal
    });
  }

  render() {
    return (
      <Modal size="sm" isOpen={this.state.modal}>
        <AddMemoPopupInner
          rootData={this.state}
          alertModal={this.props.alertModal}
          toggleModal={this.toggleModal}
        />
      </Modal>
    );
  }
}